/** Phase E — per-tenant SHADOW → AUTHORITATIVE cutover with its gate. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { StatusPill, btnGhost, btnPrimary, errorText, inputCls } from '../finance/financeUi';

export function CutoverCard({ tenantId, cut, onChange }) {
  const [period, setPeriod] = useState('');
  const [note, setNote] = useState('');
  const [gate, setGate] = useState(null);
  useEffect(() => { setPeriod(''); }, [tenantId]);
  useEffect(() => {
    if (!tenantId || !cut || cut.mode === 'AUTHORITATIVE') return;
    const p = period || cut.open_periods[0] || '';
    api.request(`/payer-runs/cutover?tenant_id=${tenantId}${p ? `&period=${p}` : ''}`).then((c) => setGate(c.gate_now)).catch(() => setGate(null));
  }, [tenantId, cut, period]);
  if (!cut) return null;
  const post = async (path) => {
    try {
      await api.request(path, { method: 'POST', body: JSON.stringify({ tenant_id: tenantId, effective_from: period || cut.open_periods[0], note }) });
      toast.success(path.endsWith('activate') ? 'Routing is now authoritative' : 'Reverted to shadow mode'); setNote(''); onChange();
    } catch (e) { toast.error(errorText(e)); }
  };
  const auth = cut.mode === 'AUTHORITATIVE';
  return (
    <div className="space-y-3 px-5 py-4 text-sm" data-testid="cutover-panel">
      <div className="flex flex-wrap items-center gap-3">
        <StatusPill value={cut.mode} testid="cutover-mode" />
        <span data-testid="cutover-summary">{auth ? `Payer routing is authoritative from ${cut.effective_from}. Earlier periods stay on the original Payout Run.` : 'Shadow mode — routing is comparison only for this tenant.'}</span>
      </div>
      {!auth && gate && (
        <>
          <p className="text-xs text-muted-foreground" data-testid="cutover-gate">
            Gate for {gate.period}: clean comparison periods {gate.clean_periods.join(', ') || 'none'} · open reviews: {gate.open_reviews}
            {gate.reasons.length > 0 && <span className="block text-amber-700">{gate.reasons.join(' · ')}</span>}
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <select className={`${inputCls} w-40`} value={period || cut.open_periods[0] || ''} onChange={(e) => setPeriod(e.target.value)} data-testid="cutover-period">
              {cut.open_periods.map((p) => <option key={p} value={p}>From {p}</option>)}
            </select>
            <input className={`${inputCls} max-w-sm`} placeholder="Cutover note (required)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="cutover-note" />
            <button type="button" className={btnPrimary} disabled={!gate.ready || !note.trim()} onClick={() => post('/payer-runs/cutover/activate')} data-testid="cutover-activate-btn">Make routing authoritative</button>
          </div>
        </>
      )}
      {auth && (
        <div className="flex flex-wrap items-center gap-2">
          <input className={`${inputCls} max-w-sm`} placeholder="Reason to revert (only before any approval)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="cutover-revert-note" />
          <button type="button" className={btnGhost} disabled={!note.trim()} onClick={() => post('/payer-runs/cutover/revert')} data-testid="cutover-revert-btn">Revert to shadow</button>
        </div>
      )}
    </div>
  );
}
